export const METER = "METER";
export const PALLET = "PALLET";
export const PIECE = "PIECE";
export const NOT_PALLET = "pieces"; // used in task documents to mark something as being "not a pallet". We only supported "pieces" from the start so that's why this is a string value.
